import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as display from '../../../display'
import type * as relay from '../../../relay'

import type { Feature } from '../feature'

/**
 * Shows the same sticky "process started" toast used by other process-backed
 * workflows after scenario creation has been accepted by GraphQL.
 */
export const showProcessToastOnCreateSuccess = store.effects.create(
  (
    feature: Feature,
    toasterFeature: display.toaster.Feature,
    processesFeature: relay.processes.Feature,
  ) =>
    feature.actions.submitEdit.success.observe().pipe(
      rxjs.filter(action => action.data.response === 'create'),
      rxjs.map(action =>
        toasterFeature.actions.show.from(action).create({
          toast: {
            actions: [
              {
                callback: () => {
                  processesFeature.actions.openSlideout
                    .from('RouteBoundScenarios.Create.Success.Toast')
                    .dispatch()
                },
                closeOnClick: true,
                id: 'view-processes',
                kind: 'button',
                name: 'View processes',
              },
            ],
            description: 'Your scenario is being set up.',
            durationMs: null,
            name: 'Scenario setup started',
          },
        }),
      ),
    ),
)
